export default "__VITE_ASSET__DWvTw0hO__"